import React, { useState, useEffect } from "react";
import Tables from "../../../../components/Tables/Tables";
import HeaderTable from "../../../../components/HeaderTable/HeaderTable";
import Modal from "../../../../components/Modal/Modal";
import Modal2 from "../../../../components/Modal/Modal";
import styled from "styled-components";
import Toast from "../../../../components/Toast/Toast";
import {
  getComponentesPaginated,
  deleteComponente,
} from "../../../../api/Configuracion";
import { buttonsDefault } from "../../../../components/ButtonsTable/ButtonsTable";
import { CircularProgress } from "@mui/material";

const columns = [
  { id: "codigo", label: "Código" },
  { id: "descripcion", label: "Descripción" },
  { id: "habilitado", label: "Habilitado" },
  { id: "buttons" },
];

const Componentes = () => {
  const [statusModal, setModalStatus] = useState(false);
  const [datosModal, setDatosModal] = useState("");
  const [componentes, setComponentes] = useState([]);
  const [componenteIdId, setComponenteId] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [itemsCount, setItemsCount] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [statusModal2, setModalStatus2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    fetchComponentesPaginated(paginaActual, orderBy, searchTerm, "primera");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderBy, paginaActual]); // Ignorando fetchComponentesPaginated y searchTerm en la dependencia array

  const fetchComponentesPaginated = async (pagina, order, search, action) => {
    const res = await getComponentesPaginated(pagina, order, search);

    setPageCount(res.data.totalPages);
    setItemsCount(res.data.totalItems);

    if (action === "new") {
      if (res.data.items.length + 1 === 21) {
        setPaginaActual(res.data.totalPages);
      }
    } else if (action === "delete") {
      setTimeout(() => {
        setSuccess(false);
      }, 1000)

    } else {
      if (res.data.totalPages === 0) {
        setPaginaActual(1);
      } else if (res.data.totalPages < paginaActual) {
        setPaginaActual(res.data.totalPages);
      } else {
        setPaginaActual(paginaActual);
      }
    }

    setComponentes(
      res.data.items.map((res) => {
        return {
          id: res.id,
          codigo: res.codigo_com,
          descripcion: res.desc_com,
          habilitado: res.status,
        };
      })
    );
  };

  const handleClickButonTable = (value, valueRow) => {
    if (value !== "Eliminar") {
      setModalStatus(true);
      setDatosModal({ button: value.toLowerCase(), datos: valueRow });
    } else {
      setComponenteId(valueRow.id);
      setModalStatus2(true);
      //handleDeleteComponente(valueRow.id)
    }
  };

  const handleClickButtonHeader = () => {
    setDatosModal("");
    setModalStatus(true);
  };

  const handleBuscador = (value) => {
    setSearchTerm(value);
    fetchComponentesPaginated(paginaActual, orderBy, value, "search");
  };

  const handleDeleteComponente = (id) => {
    setIsLoading(true);
    setModalStatus2(false);
    deleteComponente(id)
      .then(() => {
        setIsLoading(false);
        setComponenteId("");
        setKey(key + 1);
        setMsjToast("Componente eliminado con exito.");
        setSuccess(true);

        const paginaActualTemp = componentes.length === 1 && paginaActual > 1 ? paginaActual - 1 : paginaActual;
        setPaginaActual(paginaActualTemp);

        return fetchComponentesPaginated(
          paginaActualTemp,
          orderBy,
          searchTerm,
          "delete"
        );
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        setMsjToast("Error al eliminar Componente");
        setError(true);
      });
  };

  const handleOrder = (value) => {
    let valor;
    if (orderBy === "" || orderBy.replace("-", "").length !== value.length) {
      valor = value;
    } else {
      valor = orderBy;
    }

    if (valor.indexOf("-") > -1) {
      const updatedValue = valor.replace("-", "");
      setOrderBy(updatedValue);
    } else {
      const updatedValue = "-" + valor;
      setOrderBy(updatedValue);
    }
  };

  return (
    <Styled>
      {isLoading && (
        <CircularProgress
          size={30}
          sx={{
            position: "fixed",
            bottom: "0",
            padding: "10px",
            zIndex: "9999",
          }}
        />
      )}
      <div classname="toast">
        {success && (
          <Toast key={key} title={msjToast} close={() => setSuccess(false)} />
        )}
        {error && (
          <Toast
            key={key}
            type={"error"}
            title={msjToast}
            close={() => setError(false)}
          />
        )}
      </div>

      <Modal
        datos={datosModal}
        isOpen={statusModal}
        type={"componentes"}
        onClose={({ msj, status }) => {
          setSuccess(false);
          setError(false);
          if (status === "success") {
            setKey(key + 1);
            setSuccess(true);
            setMsjToast(msj);
            fetchComponentesPaginated(
              paginaActual,
              orderBy,
              searchTerm,
              msj.includes("cread") ? "new" : ""
            );
          } else if (status === "error") {
            // setKey(key+1);
            setError(true);
            setMsjToast(msj);
          } else if (status === "cancel") {
            fetchComponentesPaginated(
              paginaActual,
              orderBy,
              searchTerm,
              msj.includes("cread") ? "new" : ""
            );
          }
          setModalStatus(false);
        }}
      />

      <HeaderTable
        styledHead="cfg"
        cfg
        title="Componentes"
        valueBuscador={(value) => handleBuscador(value)}
        labelButton={"Nuevo componente"}
        onClickButton={(e) => {
          handleClickButtonHeader(e);
        }}
        value={searchTerm}
        search
        isClearable={() => {
          handleBuscador("");
        }}
      />

      <Tables
        typeTable={"prop"}
        columns={columns}
        rows={componentes}
        cRows={20}
        totalRows={itemsCount}
        actualpage={paginaActual}
        pagination={true}
        onClickSwitch={(value) => {
          handleOrder(value);
        }}
        page={(e) => setPaginaActual(e + 1)}
        pages={pageCount}
        buttons={buttonsDefault}
        onClickButtonTable={(value, valuesRow) => {
          handleClickButonTable(value, valuesRow);
        }}
      />

      <Modal2
        type="eliminar"
        isOpen={statusModal2}
        onClose={() => setModalStatus2(false)}
        onClickSuccess={() => {
          setModalStatus2(false);
          handleDeleteComponente(componenteIdId);
        }}
      ></Modal2>
    </Styled>
  );
};

export default Componentes;

const Styled = styled.div`
  padding: 20px;
  margin: auto;
  .styledTables {
    //height: 100vh;
  }
`;
